import { Button } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from 'store/store';
import { clearPaymentStatus } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Success } from 'assets/icons/success.svg';

export const PaymentSuccessModal = () => {
	const { t: paymentTranslate } = useTranslation(NamespacesList['payment']);

	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={<Success />}
			title={paymentTranslate('modals.paymentSuccess.title')}
			description={paymentTranslate('modals.paymentSuccess.description')}
			buttons={
				<Button
					className="not-rtl-able"
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '100%' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
					}}
					variant="contained"
					color="primary"
					onClick={() => {
						dispatch(clearPaymentStatus());
						handleClose();
					}}
				>
					{paymentTranslate('modals.paymentSuccess.confirm')}
				</Button>
			}
		></InfoModal>
	);
};
